var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"block lg:hidden mt-1 pb-1 mb-8 border-b"},[_c('Logo',{attrs:{"size":"sm"}})],1),_c('h1',{staticClass:"mb-5 lg:mb-12 lg:border-b lg:pb-6"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }